<template>
  <div class="footer">
    <div class="footer-main">
      <div class="footer-subscribe">
        <p><strong> Subscribe to eGalleria via Email</strong></p>
        <p>
          Subscribe to us so that you remain upto date. We promise, we won't
          spam you
        </p>
        <div class="footer-btn">
          <form @submit.prevent="subscribeNewsLetter()">
            <div class="group">
              <div class="input-group">
                <input
                  type="email"
                  v-model="email"
                  class="form-control"
                  placeholder="E-mail ID"
                  required
                />
                <div class="input-group-append">
                  <button type="submit">
                    Subscribe
                    <img
                      src="@/assets/images/roller.gif"
                      width="20px"
                      height="20px"
                      style="margin: 0 0 2px 0; border-radius: 10px"
                      v-if="fetch_loader"
                    />
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="footer-links">
        <!-- <a href="#">About Company</a> -->
        <!-- <a href="#">Support</a> -->
        <a href="/privacy/">Privacy Policy</a>
        <a href="/terms/" id="trms">Terms of Use</a>
      </div>
    </div>
    <div class="footer-footer">
      <p style="font-size:x-small" >Bengaluru, Karnataka India</p>
      <p style="font-size:x-small" >&copy;NRU Tech Private Limited (eGalleria) 2020</p>
      <div class="social-media mt-1">
        <a  href="https://www.facebook.com/eGalleriaofficial/"
          ><i
            class="fa fa-facebook h5"
            aria-hidden="true"
            style="color: white;font-size:small"
          ></i
        ></a>
        <a href="https://www.instagram.com/egalleria_official/"
          ><i
            class="fa fa-instagram h5"
            aria-hidden="true"
            style="color: white;font-size:small"
          ></i
        ></a>
        <a href="https://mobile.twitter.com/_egalleria_"
          ><i
            class="fa fa-twitter-square h5"
            aria-hidden="true"
            style="color: white;font-size:small"
          ></i
        ></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      email: "",
      fetch_loader: false,
    };
  },
  methods: {
    subscribeNewsLetter() {
      this.email = "";
        this.$notify({
          group: "error",
          title: "Successfully Subscribed",
          text: "Successfully Subscribed to eGalleria Newsletter",
        });
    },
  },
};
</script>

<style  scoped>
input:focus {
  outline: none !important;
  box-shadow: none;
  background-color: #0c0f6608;
}

.footer {
  background-color: white;
  max-height: 15vh;
  font-family: "titillium web";
  background-color: #0c0f6608;
  max-width: 100vw;
  margin-bottom: 0px;
  margin-top: 5%;
}

.footer-main {
  display: flex;
  background-color: #f4f4f4;
  justify-content: space-evenly;
  padding: 10px;
}

.footer-subscribe {
  width: 50vw;
  text-align: left;
  padding-left: 10vw;
  color: #0c0f66;
  margin-top: 1%;
}

.footer-links {
  display: flex;
  flex-direction: column;
  text-align: left;
  width: 30vw;
  /* padding: .5rem; */
  padding-left: 10vw;
}

.footer-links a {
  text-decoration: none;
  margin-bottom: 0.5rem;
  color: #0c0f66;
  font-weight: bold;
}

.footer-btn {
  display: flex;
  align-items: left;
  justify-content: left;
  width: 100%;
  float: left !important;
}

/*.footer-btn button{
    text-decoration: none;
    margin: 0;
    margin-top: 3%;
    border: 1px #0c0f66 solid;
    padding: 0.5rem 1.3rem;
    border-radius: 5px;
    color: #0C0f66;
    height: 5vh;
    
    
}*/
#email {
  border: 1px rgb(175, 172, 172) solid;
  width: 10vw;
  text-align: center;
}

.footer-footer {
  background-color: #0c0f66;
  display: flex;
  color: white;
  justify-content: space-around;
  padding: 3px;
  width: 100%;
  max-height: 6vh;
  align-items: center;
}
.footer-footer a {
  text-decoration: none;
  color: white;
  /* padding: .8rem; */
}

.social-media {
  display: flex;
  justify-items: space-between;
  align-items: center;
}

.social-media a {
  padding-right: 4vw;
}

#trms {
  margin-bottom: 0.2rem;
}

.footer-footer p {
  padding-top: 10px;
  padding-left: 10px;
  margin-bottom: 0px;
}
/* #subscribe:hover{
    background-color: #0c0f66 ;
    color: white;
} */
/*
.footer-btn input{
    height: 4.2vh;
    width: 20vw;
    display: inline-block;
    margin-top: 5px;
    margin-bottom: 3px;
    border: 0.4px rgb(126, 126, 158) solid;
    background-color: #0c0f6608;
    
    
}*/

/* .footer-btn input{
    display: inline;
    width: 100%;
    border:none;
    margin:auto;
    background-color: transparent ;
}

.footer-btn input[type=email] :focus{
    border: none;
} */

/*::placeholder{
    color: #0C0f66;
    font-size: bold;
    font-family: 'titillium web';
    text-align: center;
}*/
form {
  float: left;
}

fieldset {
  border: 2px solid #0c0f66;
  border-radius: 0.5rem;
  height: 4vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 15vw;
}

*:focus {
  outline: none !important;
  box-shadow: none;
}

.group {
  position: relative;
  border: #0c0f66 2px solid;
  max-height: fit-content;
  border-radius: 5px;
}
.group > label {
  padding: 0 1em;
  position: absolute;
  top: -0.8em;
  left: 1em;
  background-color: #ffffff;
}

button {
  background-color: #0c0f66;
  color: #ffffff;
  font-size: small;
  font-weight: bold;
  border: 2px solid #0c0f66 !important;
  padding: 0px 15px;
}
/* button:hover{
    background-color: #0c0f6608;
    color: #0C0f66;
} */
.group > .input-group > input {
  background-color: #0c0f6608 !important;
}
*:focus {
  outline: none !important;
  border: none !important;
}
@media (max-width: 768px) {
  /*.footer-btn button{
        margin-bottom: 2px;
        padding:0.5rem 1.2rem;
        font-size: smaller;

        bottom: auto;
        
        left: -11em;
        top: -1.2em;
        position: relative;
        
    }*/
  .footer-btn {
    padding-bottom: 10px;
    justify-content: left;
  }
  .footer-subscribe {
    width: 100%;
  }
  .group {
    width: 70vw;
    float: left;
  }
  .footer-main {
    flex-direction: column;
    width: 100%;
    padding: 0%;
  }
  .footer-links {
    /*padding-left: 15vw;*/
    padding-left: 0%;
    flex-direction: row;

    justify-content: space-evenly;
    width: 100%;
    /* margin-top: 5%; */
  }
}
@media (max-width: 375px) {
  .footer {
    font-size: xx-small;
  }
  .footer-btn {
    justify-content: left;
  }
  .footer-btn input {
    /*margin: auto;
        /*width: 30vw;*/
  }
  .footer-links {
    /*padding-left: 15vw;*/
    padding-left: 0%;
    flex-direction: row;

    justify-content: space-evenly;
    width: 100%;
  }
  fieldset {
    width: 20vw;
    height: 2.6vh;
  }
  /*.footer-btn button{
        padding:0.3rem 0.8rem;
        font-size: small;
        height: fit-content ;
        left: -6em;
        margin-top: 1rem;
        position: relative;
    }*/
  .footer-main {
    flex-direction: column;
    width: 100%;
    padding: 0%;
  }
  .footer-subscribe {
    width: 100%;
  }
  .group {
    width: 70vw;
  }
}

@media (min-width: 1024px) {
  .group {
    width: 40vw;
  }
  /*.footer-btn button{
        position: relative;
        margin-left: -24%;
        height: 70%;
        top: -2vh;    
    }*/
}
</style>